var map = {
	"./amex.svg": 15329,
	"./creditcard.svg": 21209,
	"./diners.svg": 54902,
	"./elo.svg": 93931,
	"./googleplay.svg": 46626,
	"./master.svg": 45726,
	"./visa.svg": 69606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63978;